import { FC, ReactNode, useEffect, useState } from "react";
import PageThumbnailSlider from "../components/creator/page-thumbnail-slider";
import ThumbnailToolBar from "../components/creator/page-thumbnail-toolbar";
import { Outlet, useLocation } from "react-router";
import { observer } from "mobx-react";
import bookCreatorProvider, { Page } from "../providers/book-creator";
import bookCreatorPageManager from "../providers/book-creator-page-manager";
import Button from "../components/common/button";
import DataEmpty from "../components/common/data-empty";
import { getBookById, getBookDetailById } from "../requests/book";
import { BookModel } from "@/types/book";
import { PhotoProvider, PhotoView } from "react-photo-view";

const BookCreatorLayout: FC<Partial<{
    children: ReactNode
}>> = ({ children }) => {
    const location = useLocation();
    useEffect(() => {
        const state = location.state;
        if (state?.id) {
            fetchBook(state.id);
        }
        return () => {
            console.log("清除")
            bookCreatorPageManager.handleSweep();
            bookCreatorProvider.performSweep();
        }
    }, []);

    const fetchBook = async (id: number) => {
        const [detail, book] = await Promise.all([getBookDetailById(id), getBookById(id)]);
        if (detail && book) {
            bookCreatorProvider.applyBook(book, detail);
        }
    }
    // useEffect(() => {
    //     return () => {
    //         bookCreatorProvider.performSweep();
    //     }
    // }, []);
    return <div className="w-screen h-screen flex bg-background dark:bg-dark-background p-2 box-border">
        <header></header>
        <div className="flex-1 relative flex h-full">
            <Slider />
            <div className="flex-1 bg-white dark:bg-dark-background rounded-md ml-2">
                {/* {children} */}
                <Outlet />
            </div>
            <ToolBar />
        </div>
    </div>;
}

const ToolBar = observer(() => {
    const [page, setPage] = useState<Nullable<Page>>();
    useEffect(() => {
        console.log("改变当前页面", bookCreatorPageManager.currentPage)
        setPage(bookCreatorPageManager.currentPage);
    }, [bookCreatorPageManager.currentPage]);

    if (!bookCreatorProvider.initialized) return <></>

    if (!page) return <div className={`bg-white dark:bg-black rounded-md p-4 ml-2 h-full relative overflow-hidden duration-600 transition-all ${bookCreatorProvider.initialized ? "w-[300px]" : "w-[0px]"}`}>
        <DataEmpty />
        暂未选择页面
    </div>
    return <div className={`bg-white dark:bg-black rounded-md p-4 ml-2 h-full relative overflow-hidden duration-600 transition-all ${bookCreatorProvider.initialized ? "w-[300px]" : "w-[0px]"}`}>
        <div className="w-full rounded-md overflow-hidden">
            <PhotoProvider>
                <PhotoView src={`${page?.image}`}>
                    <img src={`${page?.image}`} className="w-full" alt={page?.image} />
                </PhotoView>
            </PhotoProvider>
        </div>
        <div className="w-full flex py-4">
            <Button className="bg-danger/60 hover:bg-danger" onClick={() => {
                bookCreatorPageManager.handleDeleteCurrentPage()
            }}>
                删除页面
            </Button>
        </div>
    </div>
});

const Slider = observer(() => {
    return <div className={` h-full relative bg-white rounded-md overflow-hidden ${bookCreatorProvider.initialized ? "w-[260px]" : "w-[0px]"}`}>
        <div className="flex h-full ">
            <PageThumbnailSlider />
            <ThumbnailToolBar />
        </div>
    </div>
})

export default BookCreatorLayout;